import { CheckIcon } from '@heroicons/react/16/solid';
import { getTimeFromDate } from '../../../utils/dates';
import { Message } from '../api/types';
import clsx from 'clsx';

type BubbleProps = {
  message: Message;
};

export const Bubble = ({ message }: BubbleProps) => {
  const { is_me: isMe, created } = message;
  return (
    <>
      <div
        className={clsx(
          'px-2 py-1 text-sm rounded-xl max-w-[60%]',
          isMe ? 'bg-cyan-600 text-white self-end rounded-ee-none' : 'self-start bg-gray-200 rounded-es-none'
        )}>
        <span>{message.text}</span>
      </div>
      <div className={clsx('text-xs flex items-center', isMe ? 'self-end' : 'self-start ')}>
        <span>{getTimeFromDate(new Date(created))}</span>
        {isMe && (
          <CheckIcon className={clsx('size-4', message.read ? 'fill-blue-500' : 'fill-cyan-400')} />
        )}
      </div>
    </>
  );
};
